export default __webpack_public_path__ + "static/media/Mark-2-Suit-08.e63792bb.jpg";